import { SymbologyValues } from 'app/store/appSettings/AppSettingsState.ts';
import { VolumeCurveStreamRequest } from 'widgets/volumeCurve/api/VolumeCurveStreamRequest.ts';
import { VolumeCurveComponentState } from 'widgets/volumeCurve/store/component/VolumeCurveComponentState.ts';
import { Time, timeUtils } from '@instinet-analytics/core-lib';
import Order from 'communication/types/order/Order.ts';

const { toDateTime } = timeUtils;

const toRequestUid = (
    symbol: string,
    startTime: string | null,
    endTime: string | null
) => `volumeCurve-${symbol}-${startTime ?? 'null'}-${endTime ?? 'null'}`;

const timeToString = (time?: Time) =>
    time ? toDateTime(new Date(), time).toISOString() : null;

export const volumeCurveRequestToStreamKey = (
    request: VolumeCurveStreamRequest
) => {
    const { symbol, startTime, endTime } = request;
    return toRequestUid(symbol, startTime, endTime);
};
export function buildVolumeCurveRequest(
    symbol: string,
    symbology: SymbologyValues,
    order: Order,
    component?: VolumeCurveComponentState
): VolumeCurveStreamRequest {
    return {
        symbol,
        symbology,
        bucketSize: 1,
        startTime: component?.startTime
            ? timeToString(component.startTime)
            : order.timeIn
            ? new Date(order.timeIn).toISOString()
            : null,
        endTime: timeToString(component?.endTime),
    };
}

export function getStreamKey(
    symbol: string,
    symbology: SymbologyValues,
    order: Order,
    component?: VolumeCurveComponentState
) {
    return volumeCurveRequestToStreamKey(
        buildVolumeCurveRequest(symbol, symbology, order, component)
    );
}
